/**
 * Whose tax number a branch invoices under in B2B (backend
 * `BranchTaxIdentity`): the company's (COMPANY) or its own (OWN, from the
 * branch financial info).
 */
export enum BranchTaxIdentity {
  COMPANY = 'COMPANY',
  OWN = 'OWN'
}
